import DocumentUploadCard from "./documentUploadCard";
export default DocumentUploadCard;